import { render } from "./SmoothepiTermsOfUseText.vue?vue&type=template&id=da64cb22"
const script = {}

import "./SmoothepiTermsOfUseText.vue?vue&type=style&index=0&id=da64cb22&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__